var REACT_ELEMENT_TYPE;function _jsx(type, props, key, children) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var defaultProps = type && type.defaultProps,childrenLength = arguments.length - 3;if (props || 0 === childrenLength || (props = { children: void 0 }), 1 === childrenLength) props.children = children;else if (childrenLength > 1) {for (var childArray = new Array(childrenLength), i = 0; i < childrenLength; i++) childArray[i] = arguments[i + 3];props.children = childArray;}if (props && defaultProps) for (var propName in defaultProps) void 0 === props[propName] && (props[propName] = defaultProps[propName]);else props || (props = defaultProps || {});return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: void 0 === key ? null : "" + key, ref: null, props: props, _owner: null };} /* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable react/no-multi-comp */
import React from 'react';
import _ from 'lodash';
import {


  useFilters,
  usePagination,
  useRowSelect,
  useRowState,
  useTable } from
'react-table';
import { useSticky } from 'react-table-sticky';
import { t, Translate } from "../I18N";
import { Icon } from "../UI";
import { propertyValueFormatter } from "../Metadata/helpers/formater";


import { SuggestionState } from "../../shared/types/suggestionSchema";
import ModalTips from "../App/ModalTips";

const suggestionsTable = (
reviewedProperty,
suggestions,
totalPages,
actionsCell,
segmentCell) =>
{
  const formatValue = (value) => {
    if (!value) return '-';
    if (reviewedProperty.type === 'date' && _.isNumber(value)) {
      return propertyValueFormatter.date(value);
    }
    return value;
  };

  const currentValueCell = ({ row }) => {
    const propertyValue = row.values.currentValue || row.original.currentValue;
    const currentValue = formatValue(propertyValue);
    return /*#__PURE__*/(
      _jsx("div", {}, void 0, /*#__PURE__*/
      _jsx("p", { className: "current-value" }, void 0, currentValue)
      ));

  };

  const suggestionCell = ({ row }) => {
    const suggestion = row.original;
    const suggestedValue = formatValue(suggestion.suggestedValue);
    return /*#__PURE__*/(
      _jsx("div", {}, void 0, /*#__PURE__*/
      _jsx("p", { className: "suggested-value" }, void 0, suggestedValue)
      ));

  };

  const columns = React.useMemo(
    () => [
    {
      accessor: 'segment',
      Header: () => /*#__PURE__*/_jsx(Translate, {}, void 0, "Context"),
      className: reviewedProperty.label === 'Title' ? 'long-segment' : 'segment',
      Cell: segmentCell
    },
    {
      id: 'suggestion',
      Header: () => /*#__PURE__*/_jsx(Translate, {}, void 0, "Suggestion"),
      Cell: suggestionCell,
      className: 'suggestion'
    },
    {
      id: 'action',
      Header: () => /*#__PURE__*/_jsx("div", {}),
      Cell: actionsCell,
      className: 'action'
    },
    {
      id: 'currentValue',
      Header: () => /*#__PURE__*/_jsx(Translate, {}, void 0, "Current value"),
      Cell: currentValueCell,
      className: 'current'
    },
    {
      id: 'entityTitle',
      accessor: 'entityTitle',
      Header: () => /*#__PURE__*/_jsx(Translate, {}, void 0, "Title"),
      className: 'title'
    },
    {
      accessor: 'language',
      Header: () => /*#__PURE__*/_jsx(Translate, {}, void 0, "Language"),
      className: 'language',
      Cell: ({ row }) => /*#__PURE__*/
      _jsx(Translate, {}, void 0, row.original.language)

    },
    {
      accessor: 'state',
      Header: () => /*#__PURE__*/
      React.createElement(React.Fragment, null, /*#__PURE__*/
      _jsx(Translate, {}, void 0, "State"), /*#__PURE__*/
      _jsx(ModalTips, {
        label: /*#__PURE__*/_jsx(Icon, { icon: "question-circle" }),
        title: t('System', 'State Legend', 'State Legend', false) }, void 0, /*#__PURE__*/

      _jsx("h5", {}, void 0, t('System', SuggestionState.labelMatch, SuggestionState.labelMatch, false)), /*#__PURE__*/
      _jsx("div", {}, void 0, /*#__PURE__*/
      _jsx(Translate, { translationKey: "labelMatchDesc" }, void 0, "It has a current value and a text selection matching with the model suggested value and selection. It will be used as a training sample."


      )
      ), /*#__PURE__*/
      _jsx("h5", {}, void 0,
      t('System', SuggestionState.labelMismatch, SuggestionState.labelMismatch, false)
      ), /*#__PURE__*/
      _jsx("div", {}, void 0, /*#__PURE__*/
      _jsx(Translate, { translationKey: "labelMismatchDesc" }, void 0, "It has a current value and text selection but they do not match the model prediction. Accepting the suggestion will replace the current value and text selection with the suggested ones becoming a \"match / labeled\". If the labeled data is correct and the suggestion is wrong no action is needed. It will be used as a training sample."





      )
      ), /*#__PURE__*/
      _jsx("h5", {}, void 0, t('System', SuggestionState.labelEmpty, SuggestionState.labelEmpty, false)), /*#__PURE__*/
      _jsx("div", {}, void 0, /*#__PURE__*/
      _jsx(Translate, { translationKey: "labelEmptyDesc" }, void 0, "Accepting is not available since there is no suggestion. If the value is correct and the suggestion is wrong no action is needed. It will be used as a training sample."



      )
      ), /*#__PURE__*/
      _jsx("h5", {}, void 0, t('System', SuggestionState.valueMatch, SuggestionState.valueMatch, false)), /*#__PURE__*/
      _jsx("div", {}, void 0, /*#__PURE__*/
      _jsx(Translate, { translationKey: "valueMatchDesc" }, void 0, "It has a current value that matches the suggestion, but it doesn't have a text selection. Accepting will keep the value as it is and enrich it with the suggested text selection becoming a \"match / label\" that can be used as a training sample."



      )
      ), /*#__PURE__*/
      _jsx("h5", {}, void 0,
      t('System', SuggestionState.valueMismatch, SuggestionState.valueMismatch, false)
      ), /*#__PURE__*/
      _jsx("div", {}, void 0, /*#__PURE__*/
      _jsx(Translate, { translationKey: "valueMismatchDesc" }, void 0, "Accepting the suggestion will replace the current value and text selection with the suggested ones becoming a \"match / label\" that will be used as a training sample. If the current value is correct, you can still click to fill the text selection so it becomes a \"mismatch / label\" that will be used as a training sample."





      )
      ), /*#__PURE__*/
      _jsx("h5", {}, void 0,
      t('System', SuggestionState.emptyMismatch, SuggestionState.emptyMismatch, false)
      ), /*#__PURE__*/
      _jsx("div", {}, void 0, /*#__PURE__*/
      _jsx(Translate, { translationKey: "emptyMismatchDesc" }, void 0, "There is no current value and the model is suggesting a value. Accepting the suggestion will replace the current (empty) value and text selection with the suggested ones becoming a \"match / label\" that will be used as a training sample. Alternatively you can ignore the suggestion and click to fill the text selection so it becomes a \"mismatch / label\" that will be used as a training sample."





      )
      ), /*#__PURE__*/
      _jsx("h5", {}, void 0, t('System', SuggestionState.valueEmpty, SuggestionState.valueEmpty, false)), /*#__PURE__*/
      _jsx("div", {}, void 0, /*#__PURE__*/
      _jsx(Translate, { translationKey: "valueEmptyDesc" }, void 0, "Accepting is not available since there is no suggestion. If the current value is correct, you can click to fill the text selection so it becomes a \"empty / label\" that will be used as a training sample."



      )
      ), /*#__PURE__*/
      _jsx("h5", {}, void 0, t('System', SuggestionState.empty, SuggestionState.empty, false)), /*#__PURE__*/
      _jsx("div", {}, void 0, /*#__PURE__*/
      _jsx(Translate, { translationKey: "emptyDesc" }, void 0, "Both the current value and the suggestion are empty. You can click to fill the value and text selection so it becomes a \"empty / label\" that will be used as a training sample."



      )
      ), /*#__PURE__*/
      _jsx("h5", {}, void 0, t('System', SuggestionState.obsolete, SuggestionState.obsolete, false)), /*#__PURE__*/
      _jsx("div", {}, void 0, /*#__PURE__*/
      _jsx(Translate, { translationKey: "obsoleteDesc" }, void 0, "A new model is training and processing suggestions. This suggestion was created by a previous model so no actions are possible until the new suggestion is received."


      )
      )
      )
      ),

      Cell: ({ row }) => {
        const dirtyState = row.original.state !== row.values.state;
        return /*#__PURE__*/(
          _jsx("div", { className: dirtyState ? 'new-state' : '' }, void 0, /*#__PURE__*/
          _jsx(Translate, {}, void 0, row.values.state)
          ));

      },
      className: 'state'
    }],

    []
  );
  const hiddenColumns = reviewedProperty.label === 'Title' ? ['entityTitle'] : [];

  return useTable(
    {
      columns,
      data: suggestions,
      manualPagination: true,
      manualFilters: true,
      initialState: {
        hiddenColumns,
        pageIndex: 0,
        pageSize: 100
      },
      pageCount: totalPages,
      autoResetPage: false,
      autoResetFilters: false
    },
    useFilters,
    usePagination,
    useRowSelect,
    useRowState,
    useSticky
  );
};

export { suggestionsTable };